import React from "react";

export default function Register() {
  return (
  <div>
  <h1>Hi</h1>
  </div>
  );
  }

    
